import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Modal, Tooltip, OverlayTrigger } from 'react-bootstrap';
import TestPanelDetails from './testPanelDetails';
import { deleteTest } from '../../../../services/clinicPortalServices/testService';
import { getUserDetails } from '../../../../services/common/util';
import Swal from 'sweetalert2';
import { ModalStyled } from '../../../../theme/customizedStyleComponents';

import RecordDetails from '../../../common/RecordDetails';
const panelStyles = { overlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.3)', zIndex: 1040 }, panel: { position: 'fixed', top: 0, right: 0, width: '420px', height: '100vh', background: '#fff', boxShadow: '-4px 0 20px rgba(0,0,0,0.15)', zIndex: 1041, display: 'flex', flexDirection: 'column', overflowY: 'auto' }, header: { padding: '16px 20px', borderBottom: '1px solid #e0e0e0', display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#f8f9fa' }, title: { margin: 0, fontSize: '16px', fontWeight: 600, color: '#333' }, body: { padding: '20px', flex: 1 }, section: { marginBottom: '20px' }, sectionTitle: { fontSize: '11px', fontWeight: 700, color: '#888', letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: '10px', paddingBottom: '6px', borderBottom: '1px solid #eee' }, dl: { display: 'grid', gridTemplateColumns: '150px 1fr', rowGap: '8px', margin: 0 }, dt: { fontSize: '13px', color: '#555', fontWeight: 600, paddingRight: '8px' }, dd: { fontSize: '13px', color: '#222', margin: 0 }, editBtn: { background: '#0066cc', color: '#fff', border: 'none', borderRadius: '4px', padding: '6px 14px', fontSize: '13px', cursor: 'pointer', marginRight: '8px' }, closeBtn: { background: 'transparent', border: 'none', fontSize: '18px', cursor: 'pointer', color: '#666' } };

export default class EditBtnCellRenderer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            showPanel: false,
            testPanelId: props.data._id,
            errors: []
        };

        this.userName = '';
        if (getUserDetails()) {
            this.userName = JSON.parse(getUserDetails()).user_name;
        }
    }

    handleShow = () => {
        this.setState({ show: true }, () => {
            let elements = document.getElementsByClassName('removeTabIndexModal');
            if (elements.length) {
                for (let i = 0; i < elements.length; i++) {
                    let dialog = elements[i];
                    dialog.parentNode.removeAttribute('tabindex');
                }
            }
        });
    };

    handleDelete = () => {
        Swal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to recover this testPanel!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, keep it',
            customClass: {
                container:
                    window.localStorage.getItem('appTheme') === 'Dark' &&
                    /clinic|lims/.test(window.location.pathname.split('/')[1]) &&
                    'dark-swal',
                cancelButton: 'order-1',
                confirmButton: 'order-2'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                const info = {
                    _id: this.state.testPanelId
                };
                deleteTest(info).then((response) => {
                    this.props.context.componentParent.loadGridData();
                });
            }
        });
    };

    handleClose = () => {
        this.setState({ show: false });
    };

    renderPanel() {
        const d = this.props.data;
        return ReactDOM.createPortal(
            <>
                <div style={panelStyles.overlay} onClick={() => this.setState({ showPanel: false })} />
                <div style={panelStyles.panel}>
                    <div style={panelStyles.header}>
                        <h5 style={panelStyles.title}>Test Panel Details</h5>
                        <div>
                            <button style={panelStyles.editBtn} onClick={() => { this.setState({ showPanel: false }); this.handleShow(); }}><i className="fas fa-pen" style={{ marginRight: 5 }}></i>Edit</button>
                            <button style={panelStyles.closeBtn} onClick={() => this.setState({ showPanel: false })}><i className="fas fa-times"></i></button>
                        </div>
                    </div>
                    <div style={panelStyles.body}>
                        <div style={panelStyles.section}>
                            <div style={panelStyles.sectionTitle}>Panel Information</div>
                            <dl style={panelStyles.dl}>
                                <dt style={panelStyles.dt}>Name</dt><dd style={panelStyles.dd}>{d.name || '—'}</dd>
                                <dt style={panelStyles.dt}>Panel Code</dt><dd style={panelStyles.dd}>{d.panelCode || '—'}</dd>
                                <dt style={panelStyles.dt}>Type</dt><dd style={panelStyles.dd}>{d.type || '—'}</dd>
                                <dt style={panelStyles.dt}>Created By</dt><dd style={panelStyles.dd}>{d.createdBy || '—'}</dd>
                            </dl>
                        </div>
                        {d.description && <div style={panelStyles.section}><div style={panelStyles.sectionTitle}>Description</div><div style={{ fontSize: '13px', color: '#222' }}>{d.description}</div></div>}
                    
                        <RecordDetails data={d} exclude={['createdBy', 'description', 'name', 'panelCode', 'type', 'results', 'password', 'token', 'resetPasswordToken', 'refreshToken']} />
                    </div>
                </div>
            </>,
            document.body
        );
    }

    renderTooltipEdit = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Edit Test Panel
        </Tooltip>
    );

    renderTooltipDelete = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Delete Test Panel
        </Tooltip>
    );

    render() {
        return (
            <div>
                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={<Tooltip id="button-tooltip">View Test Panel</Tooltip>}>
                    <button onClick={() => this.setState({ showPanel: true })} className="edit-order-btn"><i className="fas fa-eye"></i></button>
                </OverlayTrigger>
                {this.state.showPanel && this.renderPanel()}
                <div style={{ display: 'inline-flex' }}>
                    <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={this.renderTooltipEdit}>
                        <button onClick={this.handleShow} className="edit-order-btn">
                            <i className="fas fa-pen"></i>
                        </button>
                    </OverlayTrigger>
                    <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={this.renderTooltipDelete}>
                        <button onClick={this.handleDelete} className="edit-order-btn">
                            <i className="fas fa-trash"></i>
                        </button>
                    </OverlayTrigger>
                </div>
                <ModalStyled
                    size="xl"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={this.state.show}
                    onHide={this.handleClose}
                    dialogClassName="removeTabIndexModal"
                    backdrop="static"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Update Test Panel Information</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <TestPanelDetails
                            testPanelId={this.state.testPanelId}
                            context={this.props.context}
                            handleClose={this.handleClose}
                        />
                    </Modal.Body>
                </ModalStyled>
            </div>
        );
    }
}
